<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>

      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'coachingOverview' }"
          marginBottom="5"/>

      <h6 class="element-header">Übersicht</h6>

      <div class="element-box">
        <h5 class="form-header mb-4">Gruppenmaßnahmen</h5>

        <Menu/>

        <Search
            :filters="filters"
            :loading="isSearching"
            :unemployedDropdown="unemployedDropdown"
            :operationTypeDropdown="operationTypeDropdown"
            :officeDropdown="officeDropdown"
            :coachDropdown="coachDropdown"
            @search="getCoachingList"/>

        <div class="row align-items-center justify-content-between">
          <div class="col-auto">
            <PerPage
                :values="[10, 25, 50, 100]"
                :perPage="perPageValue"
                @update:perPage="getCoachingList"/>

            <ExcelExportButton
                style="margin-right: 15px;"
                :label="$t('general.excel_export')"
                :loading="isExcelLoaded"
                @click="getExcelExport"/>
          </div>
        </div>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th>
                <a href="#"  @click.prevent="sortBy('status')">
                  <span>status</span>
                  <i :class="getIconClass('status')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('firstName')">
                  <span>Vorname</span>
                  <i :class="getIconClass('firstName')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('lastName')">
                  <span>Nachname</span>
                  <i :class="getIconClass('lastName')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('operationType')">
                  <span>Maßnahmenart</span>
                  <i :class="getIconClass('operationType')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('aaNumber')">
                  <span>JC/AA Nr</span>
                  <i :class="getIconClass('aaNumber')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('location')">
                  <span>Standort</span>
                  <i :class="getIconClass('location')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('startDate')">
                  <span>Start</span>
                  <i :class="getIconClass('startDate')"></i>
                </a>
              </th>
              <th>
                <a href="#"  @click.prevent="sortBy('endDate')">
                  <span>Ende</span>
                  <i :class="getIconClass('endDate')"></i>
                </a>
              </th>
              <th>
                <a href="#"  class=" text-end" @click.prevent="sortBy('unitsDone')">
                  <span>Stand</span>
                  <i :class="getIconClass('unitsDone')"></i>
                </a>
              </th>
              <th>
                <a href="#"  class="text-end" @click.prevent="sortBy('unitsDone')">
                  <span>Stand %</span>
                  <i :class="getIconClass('unitsDone')"></i>
                </a>
              </th>
              <th>
                <a href="#"  class="text-end" @click.prevent="sortBy('notSignedUnits')">
                  <span>UE fehlt</span>
                  <i :class="getIconClass('notSignedUnits')"></i>
                </a>
              </th>
              <th>Coaches</th>
              <th>
                <a href="#"  @click.prevent="sortBy('gevaStatus')">
                  <span>Geva Testung</span>
                  <i :class="getIconClass('gevaStatus')"></i>
                </a>
              </th>
              <th class="text-center">Einführungsunterlagen</th>
              <th>
                <a href="#"  @click.prevent="sortBy('lastUnit')">
                  <span> Letzter Termin</span>
                  <i :class="getIconClass('lastUnit')"></i>
                </a>
              </th>
              <th>CV/GEVA</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="coaching in coachingList.data" :key="coaching.id">
              <td>
                <ReportButton
                    :to="{ name: 'groupCoachingFirstInterviewForm', params: { id: coaching.id } }"/>
              </td>
              <th>
                <TypedPopover
                    :clientData="coaching.client"
                    :userRole="currentUserRole"
                    maxWidth="450px"
                    v-if="coaching.client?.specialFeatures || coaching.client?.specialFeaturesForCoach">
                  <template #trigger>
                    <span class="exclamation-badge">!</span>
                  </template>
                </TypedPopover>
              </th>
              <td>{{ coaching?.statusTranslated }}</td>
              <td>
                <div class="popover-custom">
                  <div class="popover-content position-right">
                    {{ coaching?.unemployed?.phone }} <br/>
                    {{ coaching?.unemployed?.address }} <br/>
                    {{ coaching?.unemployed?.zip }} <br/>
                    {{ coaching?.unemployed?.city }} <br/>
                  </div>
                  {{ coaching?.unemployed?.firstName }}
                </div>
              </td>
              <td>{{ coaching?.unemployed?.lastName }}</td>
              <td>{{ coaching?.nameOfCoaching?.operationTypeTranslated }}</td>
              <td>{{ coaching?.unemployed?.aaNumber }}</td>
              <td>{{ coaching?.unemployed?.location?.name }}</td>
              <td>{{ coaching?.nameOfCoaching?.startDate }}</td>
              <td>{{ coaching?.nameOfCoaching?.endDate }}</td>
              <td class="text-end">{{ coaching?.unitsDone }}</td>
              <td>
                <div class="popover-custom">
                  <div class="popover-content position-right">
                    <template v-if="
                    coaching.unitsDoneByCoach !== null &&
                    coaching.unitsDoneByCoach.length > 0">
                      <span v-for="(data, index) in coaching.unitsDoneByCoach" :key="index">
                        {{ data.firstName }} {{ data.lastName }} {{ data.units }} <br/>
                      </span>
                    </template>
                    <template v-else>
                      <span>Keine Daten</span>
                    </template>
                  </div>
                  {{ coaching?.unitsDonePercent }} %
                </div>
              </td>
              <td class="text-end">{{ coaching?.notSignedUnits }}</td>
              <td>
                <template v-for="(coach, index) in coaching.coaches" :key="index">
                  {{ coach.firstName }} {{ coach.lastName }} <br>
                </template>
              </td>
              <td>{{ coaching?.gevaStatusTranslated }}</td>
              <td>{{ coaching?.introductoryDocumentsStatus }}</td>
              <td>{{ coaching?.lastUnit }}</td>
              <td>
                <ReportButton
                    :to="{ name: 'unemployedDocumentUpload', params: {
                      id: Number(coaching.unemployed.id),
                      routeForBack: 'groupCoachingCoachingArchivedList'
                    } }"
                    label="CV/GEVA"
                    :icon="false"
                    letterSpacing="1.5px"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="coachingList?.pagination?.total_pages > 1"
            :totalPages="coachingList?.pagination?.total_pages"
            :currentPage="coachingList?.pagination?.current_page"
            :totalItems="coachingList?.pagination?.total_items"
            :perPage="coachingList?.pagination?.items_per_page"
            @pagechanged="getCoachingList"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup lang="ts">
import overviewGroupCoachingService from '@/api/CoachingOverview/GroupCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
// @ts-ignore
import {getArchivedGroupCoachingDropdown, getOfficeByUserRoleDropdown, getUserDropdown,} from '@/shared/dropdowns';
import {downloadFile, getSortIconClass} from '@/shared/functions';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Menu from '@/views/App/CoachingOverview/GroupCoaching/Menu.vue';
import Search from '@/views/App/CoachingOverview/GroupCoaching/Archived/Search.vue';
import {computed, onMounted, ref} from 'vue';
import {ICoachingOverviewFilters} from "@/interfaces/CoachingOverview/ICoachingOverviewFIlters";
import {ICoachingOverviewList, IPagination} from "@/interfaces/CoachingOverview/GroupCoaching/ICoachingOverview";
import {piniaUserStore} from "@/store/piniaUserStore";
import ClientSpecialFeaturesPopover from "@/components/ClientSpecialFeaturesPopover.vue";
import BackButton from "@/components/button/BackButton.vue";
import ReportButton from "@/components/button/ReportButton.vue";
import ExcelExportButton from "@/components/ExcelExportButton.vue";

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value?.roles?.[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const unemployedDropdown = ref([]);
const coachDropdown = ref([]);
const operationTypeDropdown = ref([]);
const officeDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const perPageValue = ref(25)
const isExcelLoaded = ref(false);

const TypedPopover = ClientSpecialFeaturesPopover as unknown as {
  new (): {
    $slots: {
      trigger: () => any
      content: () => any
    }
  }
}

const filters = ref<ICoachingOverviewFilters>({
  unemployedLastName: '',
  coachId: '',
  officeId: '',
  startDate: '',
  endDate: '',
  page: 1,
  limit: 10,
  sortBy: 'firstName',
});

const coachingList = ref<ICoachingOverviewList>({
  data: [],
  pagination: {
    current_page: 1,
    items_per_page: 10,
    total_pages: 0,
  } as IPagination,
});

async function getCoachingList(
    page = 1,
    perPage?: number,
    passedFilters?: ICoachingOverviewFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  perPageValue.value = perPage ?? perPageRes;

  try {
    const {data} = await overviewGroupCoachingService.getArchivedList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes,
    });

    coachingList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getOperationTypeDropdown() {
  operationTypeDropdown.value = getEnums?.value?.groupCoachingOperationTypes || [];
}

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

async function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy:
        filters.value.orderBy === 'DESC' ||
        filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  await getCoachingList();
}

async function getExcelExport() {
  await downloadFile('/group-coaching-overview/archived-excel-export', undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}

onMounted(async () => {
  await Promise.all([
    getCoachingList(1, perPageValue.value),
    getArchivedGroupCoachingDropdown(unemployedDropdown),
    getUserDropdown(coachDropdown),
    getOfficeByUserRoleDropdown(officeDropdown),
    getOperationTypeDropdown(),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>
/* Add cursor pointer */
.stand_popover {
  cursor: pointer;
}
</style>